module.exports = __webpack_public_path__ + "static/media/taxonomy_search.ec302083.png";